import { createNotification } from '@/components';
import IntlMessages from '@/components/utility/intlMessages';
import { useAuth } from '@/contexts/auth';
import { Button, Checkbox, Form, Input, Space } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

export function LoginForm() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submittable, setSubmittable] = useState(false);

  const values = Form.useWatch([], form);

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, values]);

  async function onSubmit(values) {
    setIsSubmitting(true);

    await login(values)
      .catch(err => {
        if (err.response) {
          if (err.response.data.code === 'email_not_verified') {
            createNotification('info', err.response.data.message);
            navigate('/confirm-email/' + values.email);
          } else {
            createNotification('error', err.response.data.message);
          }
        } else {
          createNotification('error', 'Network error');
        }
      })
      .finally(() => setIsSubmitting(false));
  }

  return (
    <Form
      layout={'vertical'}
      form={form}
      onFinish={values => {
        onSubmit(values);
      }}
    >
      <Form.Item
        name="email"
        label="E-mail"
        rules={[
          {
            required: true,
            message: 'Email is required',
          },
          {
            type: 'email',
            message: 'The input is not valid E-mail!',
          },
        ]}
      >
        <Input
          size="large"
          placeholder="saffe@saffe.com"
        />
      </Form.Item>
      <Form.Item
        name="password"
        label="Password"
        rules={[
          {
            required: true,
            message: 'Password is required',
          },
        ]}
      >
        <Input.Password
          size="large"
          type="password"
          placeholder="********"
        />
      </Form.Item>
      <Space
        align="baseline"
        className="flex justify-between"
      >
        <Form.Item/>
        <a
          className="text-primary hover:text-primary cursor-pointer"
          href="/forgot-password"
        >
          <IntlMessages id="page.signInForgotPass" />
        </a>
      </Space>
      <Space
        align="start"
        className="flex justify-between"
      >
        <div className="flex flex-col">
          <IntlMessages id="page.signInCreateAccount" />
          <a
            className="text-primary hover:text-primary cursor-pointer"
            href="/register"
          >
            <IntlMessages id="page.signInCreateAccountLink" />
          </a>
        </div>
        <Form.Item>
          <div className="flex flex-col">
            <Button
              className="bg-primary border-0 text-white !px-8 shadow-none"
              type="primary"
              shape="round"
              size="large"
              loading={isSubmitting}
              disabled={!submittable}
              htmlType="submit"
            >
              <IntlMessages id="page.signInButton" />
            </Button>
          </div>
        </Form.Item>
      </Space>
    </Form>
  );
}
